import { singleParamActionCreator } from '../../lib/singleParamActionCreator'
import { createAsyncActionType } from '../async'

export const FETCH_WHITELIST_USER_BY_EMAIL = createAsyncActionType('FETCH_WHITELIST_USER_BY_EMAIL')
export const CLEAR_WHITELIST_LOOKUP = 'CLEAR_WHITELIST_LOOKUP'

export const fetchWhitelistUserByEmail = singleParamActionCreator(FETCH_WHITELIST_USER_BY_EMAIL)
export const clearWhitelistLookup = singleParamActionCreator(CLEAR_WHITELIST_LOOKUP)
